import * as React from 'react';

import type { ICianMFUIElement } from '@cian/mf-registry/browser';
import type { IMicrofrontendManifest } from '@cian/mf-registry/shared';

export enum ESource {
  Card = 'card',
  Listing = 'listing',
  Map = 'map',
}

export enum ESubscriptionLimitType {
  /** Номер телефона **/
  PhoneNumber = 'phoneNumber',
  /** Чат **/
  Chat = 'chat',
}

export type TCheckContactsAccessParams = {
  offerId: number;
  limitType: ESubscriptionLimitType;
};

export type TEarlyAccessPaywallParams = {
  isAuthenticated?: boolean;
  source: string;
  offerId: number;
};

export enum EAccessCheckTrackingStatus {
  Granted = 'granted',
  Unauthorized = 'unauthorized',
  Unsubscribed = 'unsubscribed',
  NotSearcher = 'notsearcher',
  PaymentPending = 'paymentpending',
  Error = 'error',
}

export type TAccessCheckResult = {
  isConfirmed: boolean;
  trackingStatus: EAccessCheckTrackingStatus | null;
};

export type TContext = IContextSucceed | IContextLoading | IContextFailed;

interface IContextSucceed extends IBaseContext {
  status: EStatus.Succeed;
  manifest: IMicrofrontendManifest;
}

interface IContextLoading extends IBaseContext {
  status: EStatus.Loading;
}

interface IContextFailed extends IBaseContext {
  status: EStatus.Failed;
}

interface IBaseContext {
  status: EStatus;
  microfrontendRef: React.RefObject<ICianMFUIElement | null>;
  params: TEarlyAccessPaywallParams;
  open: boolean;
  onClose(): void;
  checkContactsAccess(params: TCheckContactsAccessParams): Promise<TAccessCheckResult>;
}

export enum EStatus {
  Succeed = 'succeed',
  Loading = 'loading',
  Failed = 'failed',
}
